import { render, staticRenderFns } from "./LegalDocumentsTab.vue?vue&type=template&id=09725b99&scoped=true&"
import script from "./LegalDocumentsTab.vue?vue&type=script&lang=js&"
export * from "./LegalDocumentsTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09725b99",
  null
  
)

export default component.exports